import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';  // <-- #1 import module

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';

import { environment } from '../environments/environment';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule, MatInputModule, MatToolbarModule, MatCardModule } from '@angular/material';
import { MatMenuModule, MatIconModule, MatListModule } from '@angular/material';
import { MatGridListModule } from '@angular/material';
import { DateAdapter, NativeDateAdapter } from '@angular/material';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material';
import { MatCheckboxModule } from '@angular/material';
import { MatTableModule } from '@angular/material';
import { MatPaginatorModule } from '@angular/material';
import { MatSelectModule } from '@angular/material';
import { MatDialogModule} from '@angular/material';
import { MatSnackBarModule } from '@angular/material';

import { AppComponent } from './app.component';
import { WeeklyComponent } from './weekly/weekly.component';

import { AppRoutingModule } from './app-routing.module';
import { FireDataService } from './fire-data.service';
import { DialogsService } from './dialogs.service';
import { OnlyLoggedInUsersGuardService } from './only-logged-in-users-guard.service';

import { TeacherComponent } from './teacher/teacher.component';
import { ClassComponent } from './class/class.component';
import { HomeComponent } from './home/home.component';
import { DailyActivityComponent } from './daily-activity/daily-activity.component';
import { CaseDailyActivityComponent } from './case-daily-activity/case-daily-activity.component';
import { UserAuthComponent } from './user-auth/user-auth.component';
import { TeacherLackComponent } from './teacher-lack/teacher-lack.component';
import { GeneralPipe, ddMMMPipe, classesToStringPipe, DDDddPipe } from './general.pipe';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ValidateOnBlurDirective } from './validate-on-blur.directive';
import { TeacherLackReportComponent } from './teacher-lack-report/teacher-lack-report.component';
import { CaseMasterComponent } from './case-master/case-master.component';
import { CaseGridComponent } from './case-grid/case-grid.component';
import { CaseGroupComponent } from './case-group/case-group.component';
import { CaseScheduleComponent } from './case-schedule/case-schedule.component';
import { CaseTeacherComponent } from './case-teacher/case-teacher.component';

@NgModule({
  declarations: [
    AppComponent,
    WeeklyComponent,
    TeacherComponent,
    ClassComponent,
    HomeComponent,
    DailyActivityComponent,
    CaseDailyActivityComponent,
    UserAuthComponent,
    TeacherLackComponent,
    GeneralPipe, ddMMMPipe, classesToStringPipe, DDDddPipe,
    ConfirmDialogComponent, ValidateOnBlurDirective, 
    TeacherLackReportComponent, CaseMasterComponent, CaseGridComponent, 
    CaseGroupComponent, CaseScheduleComponent, CaseTeacherComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase, 'my-liceo-app'), // imports firebase/app needed for everything
    AngularFireDatabaseModule, // imports firebase/database, only needed for database features
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features
        BrowserAnimationsModule,
        MatButtonModule,
        MatInputModule,
        MatToolbarModule,
        MatCardModule,
        MatMenuModule,
        MatIconModule,
        MatListModule,
        MatGridListModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatCheckboxModule,
        MatTableModule,
        MatPaginatorModule,
        MatSelectModule,
        MatDialogModule,
        MatSnackBarModule,
  ],
  entryComponents: [
    ConfirmDialogComponent,
  ],
  providers: [FireDataService, {provide: DateAdapter, useClass: NativeDateAdapter}, DialogsService, OnlyLoggedInUsersGuardService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/app.module.ts